import React from "react";

import styles from "./MyPageSection.module.scss";

type Props = {
  title: string;
};

const MyPageSection: React.FC<Props> = (props) => {
  const { title } = props;
  return <div className={styles["c-mypage__title"]}>{title}</div>;
};

export default MyPageSection;
